/**
 * Inactivity-logout constants. The debug knob `?debug_inactivity_ms=<ms>`
 * shortens both the timeout and the warning window for QA — disabled in
 * production builds.
 */
export const DEFAULT_INACTIVITY_TIMEOUT_MS = 15 * 60 * 1000; // 15 min
export const DEFAULT_WARNING_BEFORE_MS = 60 * 1000; // 60 sec warning
export const ACTIVITY_THROTTLE_MS = 5 * 1000;

const LAST_ACTIVITY_KEY = "mh_last_activity";

export function readInactivityConfig() {
  const isProd = process.env.NODE_ENV === "production";
  if (!isProd && typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    const raw = Number(params.get("debug_inactivity_ms"));
    if (Number.isFinite(raw) && raw > 3000) {
      // Warning shows at 1/3 of the remaining time, capped between 2s and DEFAULT.
      const warning = Math.max(2000, Math.min(DEFAULT_WARNING_BEFORE_MS, Math.floor(raw / 3)));
      return { timeoutMs: raw, warningMs: warning };
    }
  }
  return {
    timeoutMs: DEFAULT_INACTIVITY_TIMEOUT_MS,
    warningMs: DEFAULT_WARNING_BEFORE_MS,
  };
}

export function readLastActivity() {
  try {
    const raw = window.sessionStorage.getItem(LAST_ACTIVITY_KEY);
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch {
    return null;
  }
}

export function writeLastActivity(ts = Date.now()) {
  try {
    window.sessionStorage.setItem(LAST_ACTIVITY_KEY, String(ts));
  } catch {
    /* ignore */
  }
}

export function clearLastActivity() {
  try {
    window.sessionStorage.removeItem(LAST_ACTIVITY_KEY);
  } catch {
    /* ignore */
  }
}
